import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ModalContext } from './ModalContext'

@Component
export class ModalComponentMixin extends Vue {
  @Prop({ type: String, required: true })
  readonly id: string

  get metadata() {
    return ModalContext.instance.getMetadata(this.id)
  }

  get active(): Readonly<boolean> {
    return this.metadata ? this.metadata.active : false
  }

  set active(value: boolean) {
    ModalContext.instance.setMetadata(this.id, { active: value })
  }

  close(): void {
    this.$emit('close', this.id)
  }

  created() {
    ModalContext.instance.register(this.id)
  }

  onUpdate() {
    if (!this.metadata) ModalContext.instance.register(this.id)
  }

  beforeDestroy() {
    ModalContext.instance.unregister(this.id)
  }
}

export default ModalComponentMixin
